import FieldType from "@/ecm/variables/FieldType";
import ListElement from "@/ecm/models/contentType/ContentTypeFieldListElement";
import InternalTable from "@/ecm/models/contentType/ContentTypeFieldInternalTable";

export default class ContentTypeField {
    constructor(dto) {
        this.id = 0;
        this.code = "";
        this.name = "";
        this.default = "";
        this.remarks = "";
        this.order = -1;
        this.required = false;
        this.visible = true;
        this.readOnly = false;
        this.unique = false;
        this.type = FieldType.String;
        this.maxLength = null;
        this.mask = "";
        this.minVal = 0;
        this.maxVal = 9999;
        this.scale = 0;
        this.listType = "";
        this.listElements = [];
        this.multiValue = false;
        this.cnnStr = "";
        this.command = "";
        this.noResultQuery = "";
        this.dynamicTableId = "0";
        this.internalTable = new InternalTable();
        this.useOdbc = false;
        this.contentTypeName = "";

        if (dto) {
            this.id = dto.Id;
            this.code = dto.Code;
            this.name = dto.Name;
            this.default = dto.Default;
            this.remarks = dto.Comments;
            this.order = dto.Order;
            this.required = dto.IsRequired;
            this.visible = dto.IsVisible;
            this.readOnly = dto.IsReadOnly;
            this.unique = dto.IsUnique;
            this.type = dto.FieldType;
            this.contentTypeName = dto.ContentTypeName;

            if (this.type == FieldType.String) {
                this.maxLength = dto.MaxLength;
            }

            if (this.type == FieldType.Numeric) {
                this.mask = dto.Mask;
                this.minVal = dto.MinVal;
                this.maxVal = dto.MaxVal;
                this.scale = dto.Scale;
            }

            if (this.type == FieldType.DateTime) {
                this.mask = dto.Mask;
            }

            if (this.type == FieldType.StaticList) {
                this.listType = "S";
                this.listElements = dto.ListElements.map(function (dto) { return new ListElement(dto) });
            }


            if (this.type == FieldType.DynamicList) {
                this.listType = "D";
                this.listElements = [];
                this.multiValue = dto.SelMode == "M";
                this.useOdbc = dto.UseODBC;
                this.cnnStr = dto.CnnStr;
                this.command = dto.Command;
                this.noResultQuery = dto.NoResultQuery;
            }

            if (this.type == FieldType.DynamicTableList) {
                this.listType = "D";
                this.listElements = [];
                this.multiValue = dto.SelMode == "M";
                this.command = dto.Command;
                this.noResultQuery = dto.NoResultQuery;
                this.dynamicTableId = dto.DynamicTableID + "";
                if (dto.DynamicTable) {
                    this.internalTable = new InternalTable(dto.DynamicTable);
                }
            }
        }
    }

    getFieldType() {
        switch (this.type) {
            case FieldType.String: return "String";
            case FieldType.DateTime: return "DateTime";
            case FieldType.Numeric: return "Numeric";
            case FieldType.StaticList: return "List";
            case FieldType.DynamicList: return "List";
            case FieldType.MultiValueList: return "List";
            case FieldType.DynamicTableList: return "List";
        }
    }

    getListType() {
        switch (this.type) {
            case FieldType.StaticList: return "S";
            case FieldType.DynamicList: return "D";
            case FieldType.MultiValueList: return "D";
            case FieldType.DynamicTableList: return "D";
        }
    }

    toDto() {
        var dto = {
            Id: this.id,
            Code: this.code,
            Name: this.name,
            Default: this.default,
            Comments: this.remarks,
            Order: this.order,
            IsRequired: this.required,
            IsVisible: this.visible,
            IsReadOnly: this.readOnly,
            IsUnique: this.unique,
            Type: this.getFieldType(),
            FieldType: this.type,
            MaxLength: this.maxLength,
            Mask: this.mask,
            MinVal: this.minVal,
            MaxVal: this.maxVal,
            Scale: this.scale,
            ListType: this.getListType(),
            SelMode: this.multiValue ? "M" : "S",
            CnnStr: this.cnnStr,
            Command: this.command,
            NoResultQuery: this.noResultQuery,
            DynamicTableID: this.dynamicTableId,
            DynamicTable: this.internalTable.tableData ? Object.assign(new InternalTable(), this.internalTable).toDto() : null,
            UseODBC: this.useOdbc,
            ListElements: []
        }

        for (let i = 0; i < this.listElements.length; i++) {
            const element = this.listElements[i];
            element.order = i;
            const objElement = Object.assign(new ListElement(), element);
            dto.ListElements.push(objElement.toDto());
        }

        return dto;
    }
}